import { styled } from 'stitches.config'

export const DesktopModuleWrapper = styled('div', {
  display: 'none',

  '@bp3': {
    display: 'block',
    marginTop: '$5',
    alignSelf: 'flex-start',
    flex: '0 0 336px',
    width: '336px',
  },
})

export const DesktopCard = styled('div', {
  backgroundColor: '$accent-white',
  border: '1px solid rgba(0, 0, 0, 0.08)',
  borderRadius: '$4',
  padding: '$3',
})

export const MobileFixedContainer = styled('div', {
  position: 'fixed',
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: '$4',

  '@bp3': {
    display: 'none',
  },
})

export const MobilePanel = styled('div', {
  backgroundColor: '$accent-white',
  borderBottom: '1px solid rgba(0, 0, 0, 0.2)',
  borderTopLeftRadius: '$6',
  borderTopRightRadius: '$6',
  boxShadow: '0px -10px 20px rgba(0, 0, 0, 0.1)',
  padding: '$3',
  maxHeight: '75vh',
  overflowY: 'auto',
})

export const MobilePanelHeader = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: '$4',
  paddingBottom: '$2',
})

export const MobilePanelCloseButton = styled('button', {
  cursor: 'pointer',
  border: 'none',
  background: 'transparent',
  padding: '$1',
  marginBottom: '-$1',

  '&:focus-visible': {
    outline: '2px solid $secondary-400',
    outlineOffset: '2px',
  },
})
